import React from 'react';
import { ReactComponent as NoTripsFoundIcon } from 'Icons/noTripsfound.svg';
import { ReactComponent as LocationIcon } from 'Icons/location-new.svg';
import { ReactComponent as DistanceIcon } from 'Icons/distance.svg';
import { ReactComponent as EditIcon } from 'Icons/editIconT1.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';

const TripTable = (props) => {
    const { trips, rfqType, otherCosts } = props;
    return (
        <>
            {trips.length === 0 ? 
            <div className='tCenter'>
                <NoTripsFoundIcon className='mt-100'/>
            </div>  :
            <div className='trip-table'>
                <table className='wt-100p' cellSpacing={0} cellPadding={0}>
                    <thead>
                        <th className='pl-20'>Trip</th>
                        <th>Vehicle</th>
                        <th>Body Type</th>
                        <th>From</th>
                        <th>To</th>
                        {rfqType === 12 && <th>Route Code</th>}
                        <th>LPP</th>
                        <th>CP</th>
                        <th>Placements</th>
                        <th>TAT</th>
                        <th>Volume</th>
                        <th>Actions</th>
                    </thead>
                    <tbody>
                        {(trips || []).map((trip) => {
                            return(
                                <tr>
                                    <td><div className='pl-20'>1</div></td>
                                    <td>{trip.vehicleTypeName}</td>
                                    <td>{trip.vehicleBodyTypeName}</td>
                                    <td>
                                        <span className='text-border from'><LocationIcon className='mr-5' />{trip.from}</span>
                                    </td>
                                    <td>
                                        <span className='text-border to'><LocationIcon className='mr-5' />{trip.to}</span><br/>
                                        <div className='mt-10'><DistanceIcon /> Distance - {trip.distance} {trip.distanceUOM} </div>
                                    </td>
                                    {rfqType === 12 && <td>
                                        {trip.routeCode}
                                    </td>}
                                    <td>{trip.lpp || 'N/A'}</td>
                                    <td>
                                        {trip.rfqType === 12 ? <>{(trip.biddingDetails || {}).qbr || '-'}</> :
                                        <>
                                            <>
                                                {trip.multi_mode_leg_trip && trip.multi_mode_leg_trip.length > 1 && <span>Total Cost:</span>}{trip.biddingDetails[`qbr_inr`] && <span>{trip.biddingDetails[`qbr_inr`] && `₹${Number(trip.biddingDetails[`qbr_inr`]).toFixed(2)}` || '-'}</span>}
                                            </>
                                            {(trip.biddingDetails.qbr_inr && trip.priceInBaseCurrency !== 'INR') ? <><span className="ml-5">{trip.biddingDetails.qbr_inr && `${trip.priceInBaseCurrencySymbol}${Number(trip.priceInBaseCurrency === "USD" ? trip.biddingDetails[`qbr_usd`] : (trip.biddingDetails[`qbr_secondary`] || 0)).toFixed(2)}` || '-'}</span><br></br></>
                                            : ''}<br/>
                                            <span className="ml-5 theme-color fs-12 fBold">{otherCosts ? "(Includes Other Costs)" : "(Excludes Other Costs)"}</span>
                                        </>}
                                    </td>
                                    <td>{trip.placementTimeFormatted} </td>
                                    <td>{trip.biddingDetails.tatValue} {trip.biddingDetails.tatUnitName}</td>
                                    <td>{trip.biddingDetails.businessVolumeValue} {trip.biddingDetails.businessVolumeUnitName}</td>
                                    <td>
                                        <EditIcon className="wt-20 ht-20 curP" fill={"#627FE9"} onClick={() => props.editTrip(trip)}/>
                                        <DeleteIcon className="wt-15 ht-15 ml-10 curP" onClick={() => props.deleteTrip(trip)}/>
                                    </td>
                             </tr>)
                        })}
                    </tbody>
                </table>
            </div>}
        </>
    )
}

export default TripTable;